export default "__VITE_ASSET__$kJoWSYu__"